import { combineReducers } from 'redux';

import configReducer from './config-reducer';
import historyReducer from './history-reducer';
import uiReducer from './ui-reducer';

const allReducers = combineReducers({
  config: configReducer,
  history: historyReducer,
  ui: uiReducer,
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js